import {
  BodyText,
  CardHeader,
  NextSeparator,
  NextStatusBadge,
  Spinner,
} from '@cint/wonderment';

import { ConnectionStatus, STATUS_BADGE } from './ConnectionStatusCard';

export interface IntegrationSummary {
  label: string;
  status: ConnectionStatus;
}

export interface IntegrationsCardHeaderProps {
  integrations: IntegrationSummary[];
  isLoading?: boolean;
  isExpanded?: boolean;
}

export const IntegrationsCardHeader = ({
  integrations,
  isLoading = false,
  isExpanded = false,
}: IntegrationsCardHeaderProps) => (
  <CardHeader
    collapsibleIconAlignment="left"
    titleSlot={
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
        <BodyText fontWeight="bold" className="ds-text-display">
          Integrations
        </BodyText>
        {/* Once expanded each provider's own card shows its name and status,
            so the summary in the header would only repeat it. */}
        {!isExpanded && (
          <>
            <div className="h-6 shrink-0">
              <NextSeparator variant="content" direction="vertical" />
            </div>
            <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
              {integrations.map(({ label, status }) => (
                <div key={label} className="flex items-center gap-2">
                  <BodyText fontWeight="bold" className="ds-text-display">
                    {label}
                  </BodyText>
                  {isLoading ? (
                    <Spinner size="sm" />
                  ) : (
                    <NextStatusBadge
                      color={STATUS_BADGE[status].color}
                      label={STATUS_BADGE[status].label}
                      withDot
                    />
                  )}
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    }
  />
);
